/**
 * slikSaved() — the ONE global "Saved!" burst (Jose 2026-10-23: "when anything is changed it just shows
 * boom — Saved"). Module-level + DOM-based (no React state, no context, no server wait) so ANY surface or
 * handler can fire it and it appears INSTANTLY — the delay on the old modal-local burst was waiting on the
 * save to resolve; this fires the moment the LOCAL change applies. Big center green check that pops + fades.
 * Call it right after the optimistic/local write (pairs with the background-writes doctrine).
 */
export function slikSaved(text = 'Saved!'): void {
  if (typeof document === 'undefined') return;
  document.getElementById('slik-saved-burst')?.remove(); // never stack

  const wrap = document.createElement('div');
  wrap.id = 'slik-saved-burst';
  wrap.style.cssText =
    'position:fixed;inset:0;z-index:100090;display:flex;align-items:center;justify-content:center;pointer-events:none;';

  const card = document.createElement('div');
  card.style.cssText =
    "display:flex;flex-direction:column;align-items:center;gap:10px;padding:24px 34px;border-radius:24px;" +
    "background:rgba(16,185,129,0.97);box-shadow:0 20px 60px rgba(0,0,0,0.38);";
  card.innerHTML =
    '<div style="width:70px;height:70px;border-radius:9999px;background:#fff;display:flex;align-items:center;justify-content:center;">' +
      '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
    '</div>' +
    '<div style="color:#fff;font-weight:800;font-size:22px;font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',Roboto,sans-serif;">' +
      String(text).replace(/</g, '&lt;') +
    '</div>';

  wrap.appendChild(card);
  document.body.appendChild(wrap);

  try {
    const anim = card.animate(
      [
        { transform: 'scale(0.6)', opacity: 0 },
        { transform: 'scale(1.06)', opacity: 1, offset: 0.32 },
        { transform: 'scale(1)', opacity: 1, offset: 0.62 },
        { transform: 'scale(1)', opacity: 0 },
      ],
      { duration: 1150, easing: 'ease-out' },
    );
    anim.onfinish = () => wrap.remove();
  } catch { /* no WAAPI — fall through to the timeout removal */ }
  setTimeout(() => wrap.remove(), 1400);
}

if (typeof window !== 'undefined') (window as any).slikSaved = slikSaved;
